import React from "react";
import PropTypes from "prop-types";
import { Route, useHistory, Switch } from "react-router-dom";
//Material imports
import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
//Limitless imports
import HowItWorksScreen from "../screens/HowItWorksScreen";
import CreateMessageScreen from "../screens/CreateMessageScreen";
import ConversationScreen from "../screens/ConversationScreen";
import HistoryScreen from "../screens/HistoryScreen";
import NewMessageScreen from "../screens/NewMessageScreen";
import MaintenanceScreen from "../screens/MaintenanceScreen";
import { ClientContext } from "@limitless/common/utils";
import { useCustomerContext } from "@limitless/customer/hooks";
import { useMobileDetectionContext } from "hooks/mobile-detection/MobileDetectionContext";

const Routes = ({ sessionMessage, fromEmail, maintenanceContent }) => {
    const history = useHistory();
    const { updateEmailViewed } = useCustomerContext();
    const { offsetStyles, isMobileDevice } = useMobileDetectionContext();

    React.useEffect(() => {
        const { blockAppEntry, osContent } = maintenanceContent;

        if (blockAppEntry) {
            history.push("/maintenance", { content: osContent });
        } else if (fromEmail) {
            updateEmailViewed(true);
            let overrideCustConfirmation,
                overrideAccepted = false;
            if (ClientContext._displayAcceptRateCapture === "true") {
                overrideCustConfirmation = true;
            }
            if (ClientContext._displayRateCaptureOnly === "true") {
                overrideAccepted = true;
            }
            history.push(
                `/conversation/${ClientContext._messageId}/${
                    ClientContext._accessKey
                }/${true}/${overrideCustConfirmation}/${overrideAccepted}`
            );
        } else if (sessionMessage && sessionMessage.accessKey) {
            history.push(`/conversation/${sessionMessage.messageId}/${sessionMessage.accessKey}/${true}`);
        } else if (ClientContext._hiwMode === "informational") {
            history.push("/createMessage");
        }
    }, []);

    return (
        <Slide in direction="up" timeout={500} appear={ClientContext._animation}>
            <Paper
                elevation={10}
                className="llm-root"
                style={{ ...offsetStyles, ...(!isMobileDevice && { maxHeight: ClientContext._llmHeight }) }}
                square
            >
                <Switch>
                    <Route exact path="/" component={HowItWorksScreen} />
                    <Route path="/createMessage" render={routeProps => <CreateMessageScreen {...routeProps} />} />
                    <Route path="/history" render={routeProps => <HistoryScreen {...routeProps} />} />
                    <Route path="/newMessage" component={NewMessageScreen} />
                    <Route
                        exact
                        path={[
                            "/conversation/:messageId/:accessKey/:isHistoryMessage",
                            "/conversation/:messageId/:accessKey/:isHistoryMessage/:overrideCustConfirmation",
                            "/conversation/:messageId/:accessKey/:isHistoryMessage/:overrideCustConfirmation/:overrideAccepted"
                        ]}
                        render={routeProps => <ConversationScreen {...routeProps} />}
                    />
                    <Route
                        path="/conversation/:messageId/:accessKey/:isHistoryMessage"
                        render={routeProps => <ConversationScreen {...routeProps} />}
                    />
                    <Route
                        path="/conversation/:messageId/:isHistoryMessage"
                        render={routeProps => <ConversationScreen {...routeProps} />}
                    />
                    <Route path="/maintenance" component={MaintenanceScreen} />
                </Switch>
            </Paper>
        </Slide>
    );
};

export default Routes;

Routes.propTypes = {
    fromEmail: PropTypes.bool.isRequired,
    sessionMessage: PropTypes.object,
    maintenanceContent: PropTypes.object
};
